import { FunctionComponent, h } from 'preact';
import { useStore } from '../../../helpers/use-store';
import { observer } from 'mobx-react';
import Avatar from '../../../components/avatar/avatar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-solid-svg-icons/faTimes';
import { useCallback, useState } from 'preact/hooks';
import Modal from '../../../components/modal/modal';
import MessageDriver from './message-driver/message-driver';
import DriverActions from './driver-actions/driver-actions';

const TrackingDriverCard: FunctionComponent = () => {
	const [messageModalVisible, setMessageModalVisible] = useState(false);

	const {
		driverTrackingStore: {
			customerExperience: { employee_name, employee_image, job_description }
		}
	} = useStore();

	const toggleDriverMessageModal = useCallback(
		() => setMessageModalVisible(!messageModalVisible),
		[messageModalVisible]
	);
	const { ariaStore } = useStore();

	return (
		<div className="tracking-driver-card" data-testid="tracking-driver-card">
			<Avatar
				className="tracking-driver-card-avatar"
				title={employee_name}
				description={job_description}
				profileUrl={employee_image}
				ariaHidden={ariaStore.isModalOpen}
			/>
			<DriverActions onMessageClick={toggleDriverMessageModal} />

			<Modal isOpen={messageModalVisible}>
				<div className="tracking-driver-card-close-modal-content">
					<FontAwesomeIcon
						className="tracking-driver-card-close-modal-icon"
						onClick={toggleDriverMessageModal}
						icon={faTimes}
					/>
				</div>
				<MessageDriver onMessageSubmit={toggleDriverMessageModal} />
			</Modal>
		</div>
	);
};

export default observer(TrackingDriverCard);
